module.exports = __webpack_public_path__ + "img/x-icon.3d88f78b.svg";